// @ts-ignore
import type { Node } from 'react';
import React, { useRef } from 'react';
import RailContext from '../RailContext';
import Desktop from './components/Desktop';
import Mobile from './components/Mobile';

type RailProps = {
  children: Node[],
  onFacetChange?: (option: { [_: string]: any }) => void,
  newDashboard?: boolean,
  hasLeftFacetedGrid?: boolean,
  hasMarketingDataEBB?: boolean,
  isBRRedesignEnabled?: boolean,
  isBRRedesignOpacityEnabled?: boolean,
  isModelToggleEnabled?: boolean,
  appliedFacetsCount: number,
};

const Rail = (props: RailProps) => {
  const {
    children,
    appliedFacetsCount,
    newDashboard = false,
    hasLeftFacetedGrid = false,
    hasMarketingDataEBB = false,
    isBRRedesignEnabled = false,
    isBRRedesignOpacityEnabled = false,
    isModelToggleEnabled = false,
    ...context
  } = props;

  const scrollableRef = useRef<HTMLElement>(null);

  return (
    <RailContext.Provider value={{
      ...context,
      scrollableRef: scrollableRef.current,
    }}
    >
      {hasLeftFacetedGrid ? (
        <Desktop>
          {children}
        </Desktop>
      ) : (
        <Mobile
          appliedFacetsCount={appliedFacetsCount}
          hasMarketingDataEBB={hasMarketingDataEBB}
          isBRRedesignEnabled={isBRRedesignEnabled}
          isBRRedesignOpacityEnabled={isBRRedesignOpacityEnabled}
          isModelToggleEnabled={isModelToggleEnabled}
          newDashboard={newDashboard}
        >
          {children}
        </Mobile>
      )}
    </RailContext.Provider>
  );
}
;

Rail.defaultProps = {
  hasLeftFacetedGrid : false,
  newDashboard : false,
  isBRRedesignEnabled: false,
  isModelToggleEnabled : false,
  onFacetChange : () => {},
};

export default Rail;
